import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import PenaltyType from "../../../enums/penalty-type";
import StatsRule from "../../../../common/stats-rule";

export default class PenaltyAcceptedStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PenaltyAccepted ||
            fragment.associatedState ===
                FootballState.PlayPenaltyPenaltyAccepted ||
            fragment.associatedState === FootballState.KickOffPenaltyAccepted
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const kickedOutOfBounds =
            play.getPreviousFragment(fragment).penaltyType.code ===
            PenaltyType.KickedOutOfBounds.code;

        let penaltyYards = kickedOutOfBounds
            ? 5
            : (fragment.fieldPosition - fragment.enforcementSpot) *
              gameContext.getFieldDirectionMultiplier();

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: fragment.causedBy.teamId,
            playerId: fragment.causedBy.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.PENALTY,
            values: { yards: penaltyYards, completed: 1 }
        });
    }
}
